import Swiper from "swiper";

export class Navigation {
    constructor(element, gallery) {
        this.element = element;
        this.gallery = gallery;
    }

    get slides() {
        return [...this.element.querySelectorAll('.swiper-slide')];
    }

    get active() {
        return this.slides.length > 1;
    }

    init() {
        if(!this.active) {
            this.element.style.display = 'none';
            return;
        }

        this.swiper = new Swiper(this.element, {
            slidesPerView: 6,
            slidesPerGroup: 6,
            spaceBetween: 32
        });

        this.slides.forEach((slide, index) => {
            slide.addEventListener('click', event => {
                this.gallery.changeSlide(index)
            });
        });


    }

    slideTo(index) {
        if(!this.active) {
            return;
        }
        const className = 'gallery__current-nav-slide';
        const currentSlide = this.slides[index];
        this.slides.forEach(slide => slide.classList.remove(className))
        currentSlide.classList.add(className)

        this.swiper.slideTo(index);
    }
}
